import { navigateTo } from "../../../../widgets/navigationService/navigationServiceFunctions";

export function redirectToDocumentPreview(documentId: any) {
    navigateTo(documentId, { relative: true })
}